import localforage from "localforage";

const _showLogs = true;

export const cachePrefixTypes = {
  appDataDocuments: 'appDataDocuments',
  clientProfiles: 'clientProfiles',
  event: 'event',
  notifications: 'notifications',
  settings: 'settings',
}

export const useCache = () => {

  const clearSelectedCache = async () => {
    await localforage.removeItem(docName);
    _showLogs && console.log(`🗑️ Cleared cache for ${docName}`);
    setCurrentData(undefined);
  };

  const clearDataCache = async (cachePrefixType) => {
    const keys = await localforage.keys();

    // Filter keys that start with your prefix
    const dataKeys = keys.filter(k => k.startsWith(cachePrefixType));

    // Remove them all in parallel
    await Promise.all(dataKeys.map(k => localforage.removeItem(k)));

    console.log(`🧹 Removed ${dataKeys.length} items with prefix "${cachePrefixType}"`);
    return dataKeys;
  }

  const clearAllCache = async () => {
    await localforage.clear();
    // re-run the listener manually if needed
    _showLogs && console.log(`🔁 Cache cleared`);
  };

  return {
    clearSelectedCache,
    clearDataCache,
    clearAllCache,
  };
}; 